import React, { useEffect, useState } from "react";
import {
  Navigate,
  Outlet,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "@/store/store";

const ProtectedAccess: React.FC = () => {
  const { entityName } = useParams<{ entityName: string }>();
  const navigate = useNavigate();
  const location = useLocation();
  const decodedPathname = decodeURIComponent(location.pathname);
  const user = useSelector((state: RootState) => state.user.user);
  const {userCity, userAo} = useSelector((state: RootState) => state.entity);
  const isAuthenticated = user.user_type !== "";
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    const checkAccess = () => {
      if (!isAuthenticated) {

        navigate(`/${entityName}`);
        return;
      }

      const allowedUserRoutes = [
        `/${entityName}/city`,
        `/${entityName}/user/settings`,
        `/${entityName}/projects`,
        `/${entityName}/outline_plans`,
        `/${entityName}/projects/create`
      ];

      const notAllowedSuper = [`/${entityName}/admins/`, `/${entityName}/projects`];
      const notAllowedAdmin = [`/${entityName}/cities`];
      const notAllowedOffice = [`/${entityName}/city`];
      
      // Super admin routes that bypass entity name check
      const superAdminBypassRoutes = [
        `/${entityName}/managment/city-parameters`,
        `/${entityName}/managment/general-parameters`
      ];

      // Allow super admins to access city parameters management regardless of entity name
      if (user.user_type === "super_admin" && 
          superAdminBypassRoutes.some((path) => decodedPathname.startsWith(path))) {
        setIsChecking(false);
        return;
      }

      const pathMatch =
        (notAllowedOffice.some((path) => decodedPathname.startsWith(path)) &&
          user.user_type === "external_municipal") ||
        (!allowedUserRoutes.some((path) => decodedPathname.startsWith(path)) &&
          user.user_type === "internal_municipal") ||
        (notAllowedSuper.some((path) => decodedPathname.startsWith(path)) &&
          user.user_type === "super_admin") ||
        (notAllowedAdmin.some((path) => decodedPathname.startsWith(path)) &&
          user.user_type === "admin") ||
        ((decodedPathname !== `/${entityName}` ||
          decodedPathname !== `/${entityName}/`) &&
          ((userCity && userCity.name.toLowerCase() !== entityName?.toLowerCase())) || (userAo && userAo.name.toLowerCase() !== entityName?.toLowerCase()))

      if (pathMatch) {
        navigate("/403");
      } else {
        setIsChecking(false);
      }
    };

    checkAccess();
  }, [location.pathname, user, userCity, userAo, entityName, isAuthenticated, navigate]);

  if (!isAuthenticated) {
    return <Navigate to={`/${entityName}`} />;
  }

  if (isChecking) {
    return null;
  }

  return <Outlet />;
};

export default ProtectedAccess;